import { Component, Input, OnInit } from '@angular/core';
import { PumpService } from '../services/pump.service';
import { MatPaginator, MatSort, MatTableDataSource, MatDialog, MatDialogConfig, MatTooltipModule, MatDialogRef } from '@angular/material'
import { PumppopuptableComponent } from '../pumppopuptable/pumppopuptable.component';
import { element } from 'protractor';
import * as moment from 'moment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import * as _ from 'lodash';
interface Transformer {
  id: string;
  name: string;
  siteName: string;
  location: string;
}

@Component({
  selector: 'app-pumpdashboard',
  templateUrl: './pumpdashboard.component.html',
  styleUrls: ['./pumpdashboard.component.scss']
})
export class PumpdashboardComponent implements OnInit {
  pump1dplowimg="NO";
  pump2dplowimg="NO";
  totalWaterFlow: any = 0;
  waterLeveld: any = 0;
  seleteddeviceid;
  pumponedp = 0;
  overload = 1;
  tileData;
  pumptwodp = 0;
  pumponestatus = 0;
  pumptwostatus = 0;
  selectedParameter;
  totalPumpData;
  pumpIdsArray;
  jsonReadings = [];
  showTooltip: boolean = false;
  waterpercentage = 900;
  dateAray = [];
  waterlevel;
  lat = 21.2514; // Map center latitude
  lng = 81.6296; // Map center longitude
  markerLat = 21.2514; // Marker latitude
  markerLng = 81.6296; // Marker longitude
  markerIconUrl = 'path/to/marker-icon.png'; // Marker icon URL
  data;
  lightningTransformerFeedback;
  buchholz = 1;
  abswitch = 0;
  sumplevel = 0;
  selectOptions: Transformer[] = [
    { id: "JSW-1132", name: 'JSW-1132', siteName: 'Rajkot', location: 'Gujarat' },
    { id: 'JSW-1133', name: 'JSW-1133', siteName: 'Jamnagar', location: 'Gujarat' },
    { id: 'JSW-1134', name: 'JSW-1134', siteName: 'Bhavnagar', location: 'Gujarat' }
    // Add more transformers as needed
  ];
  selectedpumps = [
    { name: 'pump-1' },
    { name: 'pump-2' },
    { name: 'pump-3' }
  ];
  graph: any = {
    layout: {
      title: "",
      autosize: true,
      responsive: true, // Make the graph responsive
      xaxis: {
        title: {
          text: 'Time',
          font: {
            family: 'Arial',
            size: 18,
            color: '#000000',
          }
        },
      },
      yaxis: {
        title: {
          text: 'Value',
          font: {
            family: 'Arial',
            size: 18,
            color: '#000000'
          }
        }
      },
      shapes: []
    },
    config: { displaylogo: false, modeBarButtonsToRemove: ['zoom2d', 'pan2d', 'select2d', 'lasso2d', 'toggleSpikelines', 'hoverClosestCartesian', 'hoverCompareCartesian'] }
  };
  graphsumplevel: any = {
    layout: {
      title: "",
      autosize: true,
      responsive: true, // Make the graph responsive
      xaxis: {
        title: {
          text: 'Time',
          font: {
            family: 'Arial',
            size: 18,
            color: '#000000',
          }
        },
      },
      yaxis: {
        title: {
          text: 'Value',
          font: {
            family: 'Arial',
            size: 18,
            color: '#000000'
          }
        }
      },
      shapes: []
    },
    config: { displaylogo: false, modeBarButtonsToRemove: ['zoom2d', 'pan2d', 'select2d', 'lasso2d', 'toggleSpikelines', 'hoverClosestCartesian', 'hoverCompareCartesian'] }
  };
  sumpdate;
  sumpdata;
  selectedpump = this.selectedpumps && this.selectedpumps.length > 0 ? this.selectedpumps[0].name : null; // Select the first pump by default
  sumpvalues;
  selectedOption = this.selectOptions && this.selectOptions.length > 0 ? this.selectOptions[0].id : null; // Select the first transformer by default
  selectedTransformer: Transformer; // Variable to hold the selected transformer details
  alertdata = [
  ];
  showcurrent: boolean;
  totalPumpOnTimeInHours: number=0;
  totalPumpOnTimeInMinutes: number=0;
  totalPumpOnTimeInSeconds: number=0;
  totalPumpOnTimeInDays: number =0;
  totalPumpOnTime: number;
  hasData: boolean; // Flag to check if data exists

  constructor(private pumpservice: PumpService, private matDialog: MatDialog, private ngxLoader: NgxUiLoaderService) { }
  currentUserData = JSON.parse(localStorage.getItem('userData'));
  ngOnInit() {
    this.ngxLoader.startLoader('dashboard');
    this.getpumpIds();

  }

  getpumpIds() {
    let data = { "roleid": this.currentUserData.roleid, "userid": this.currentUserData.userid };
    this.pumpservice.getPumpIds(data).subscribe(async (response1: any) => {
      console.log("ksajdhgsatdashbksankdasdvasuhjdinasuhda", response1.result)
      this.totalPumpData = response1.result;
      if (response1.result.length > 0) {
        this.pumpIdsArray = response1.result.map(pump => pump.pump_id);
        this.alldata(this.pumpIdsArray);
        await this.getGraphData(this.pumpIdsArray[0]);
        this.getAlerts(this.pumpIdsArray);
      }
    });
  }
  alldata(pumpIdsArray) {
    let data = { "userid": this.currentUserData.userid, "selectedPumpId": pumpIdsArray };
    this.pumpservice.pumpdashboard(data).subscribe((response1: any) => {
      this.hasData = response1 && response1.length > 0; // Check if data exists
 
      console.log("response tile data", response1)
      this.tileData = response1.tiledata;
      let pumpreadingsjson = [];
      let sumpLevels = [];
      let sdate = [];

      for (let i = response1.data.length - 1; i >= 0; i--) {
        const dataItem = response1.data[i];
        const pumpreading = JSON.parse(dataItem.pumpreadings);

        if (pumpreading && pumpreading.hasOwnProperty('Sump_Level')) {
          sumpLevels.push(pumpreading.Sump_Level);
          sdate.push(pumpreading.Date);

          if (sumpLevels.length === 5) {
            break;
          }
        }
      }

      this.sumpdata = sumpLevels;
      this.sumpdate = sdate;
      let pump1readings = JSON.parse(response1.data[response1.data.length - 2].pumpreadings);
      let pump2readings = JSON.parse(response1.data[response1.data.length - 1].pumpreadings);
      this.pumponedp = pump1readings.pumpdplow;
      this.pumptwodp = pump2readings.pumpdplow;
      this.pumponestatus = pump1readings.pumponffeedback;
      this.pumptwostatus = pump2readings.pumponffeedback;
      if (pump1readings.pumpdplow == 0) {
        this.pump1dplowimg = 'YES';
      } else if (pump1readings.pumpdplow == 1) {
        this.pump1dplowimg = 'NO';
      }
      if (pump2readings.pumpdplow == 0) {
        this.pump2dplowimg = 'YES';
      } else if (pump2readings.pumpdplow == 1) {
        this.pump2dplowimg = 'NO';
      }
    });

  }
  convertSecondsToTimeUnits(totalSeconds: number) {
    this.totalPumpOnTimeInDays = Math.floor(totalSeconds / 86400);
    totalSeconds %= 86400;
    this.totalPumpOnTimeInHours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    this.totalPumpOnTimeInMinutes = Math.floor(totalSeconds / 60);
    this.totalPumpOnTimeInSeconds = totalSeconds % 60;
    console.log("Total On Time:", 
      `${this.totalPumpOnTimeInDays} days, ` + 
      `${this.totalPumpOnTimeInHours} hours, ` + 
      `${this.totalPumpOnTimeInMinutes} minutes, and ` + 
      `${this.totalPumpOnTimeInSeconds} seconds`
    );
  }
  calculatePumpOnTime(data): number {
    let pumpOnTime = 0;
    let startTime: Date | null = null;

    data.forEach(record => {
      // Remove extra quotation marks from the date string
      const cleanedDate = record.Date.replace(/'/g, '');

      if (record.pumponffeedback === 1) {
        if (startTime === null) {
          startTime = new Date(cleanedDate);
        
        }
      } else {
        if (startTime !== null) {
          const endTime = new Date(cleanedDate);
         pumpOnTime += (endTime.getTime() - startTime.getTime()) / 1000;
          startTime = null;
        }
      }
    });

    // If pump was still on at the end of the data period
    if (startTime !== null) {
      const endTime = new Date(data[data.length - 1].Date.replace(/'/g, ''));
     pumpOnTime += (endTime.getTime() - startTime.getTime()) / 1000;
    }

   
    this.convertSecondsToTimeUnits(pumpOnTime);
    return pumpOnTime;
  }
  getAlerts(pumpid) {
    this.pumpservice.getPumpAlerts({ pumpid: pumpid }).subscribe((response: any) => {
      if (response.result.length > 0) {
        this.alertdata = response.result;
      } else {
        this.ngxLoader.stopLoader('dashboard');
      }

    });

  }
  sumpLevel(value) {

    var options = {
      series: [value],
      chart: {
        height: '100%',
        width: '100%',
        type: 'radialBar',
        offsetY: 0
      },
      title: {
        align: 'center',
        style: {

          fontWeight: 'bold',
          color: '#333'
        }
      },
      plotOptions: {
        radialBar: {
          startAngle: -160,
          endAngle: 160,
          dataLabels: {
            name: {
              fontSize: '70%',
              color: '#964B00',
              offsetY: '-5%'
            },
            value: {
              offsetY: 0,
              fontSize: '100%',
              color: 'black',
              formatter: function (val, opts) {
                return val + '%';
              }
            }
          }
        }
      },

      colors: ['#996633'],

      stroke: {
        dashArray: 0
      },
      labels: ['Sump Level'],
      grid: {
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        }
      }
    };

    let chart = new ApexCharts(document.querySelector("#sumpLevel"), options);
    chart.render();
  }
  popupTable(state, selected) {
    console.log('data==edit==', state);
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.height = '80%';
    dialogConfig.width = '70%';
    dialogConfig.data = {
      type: state,
      TransformerData: this.totalPumpData
    };

    let dialogRef = this.matDialog.open(PumppopuptableComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((response) => {
    })
  }
  updateSelected(selectedParameter) {
    this.selectedParameter = selectedParameter;
    this.createGraph();
  }
  getGraphData(selectedpump) {
    this.jsonReadings = [];
    this.selectedpump = selectedpump;
    this.pumpservice.getSelectedPumpData({ pumpid: selectedpump }).subscribe((response: any) => {
      console.log(" response.result", response.result);
      if (response.result.length > 0) {
        response.result.forEach(element => {
          this.dateAray.push(element.Timestamp);
          this.jsonReadings.push(JSON.parse(element.pumpreadings));
        });
        console.log(" this.jsonReadings", this.jsonReadings)
        this.jsonReadings.forEach(element =>{
          if(element.pumponffeedback == 0){
            element.L1 = 0;
            element.L2 = 0;
            element.L3 = 0;
          }
        })
        this.totalPumpOnTime = this.calculatePumpOnTime( this.jsonReadings);

        let lastIndex = this.jsonReadings.length - 1;
        let lastReading = this.jsonReadings[lastIndex];
        console.log(" lastreadings from graph data", lastReading)
        if (lastReading) {
          if (lastReading.pumponffeedback == 1) {
            this.showcurrent = true;
          }
          else {
            this.showcurrent = false;
          }
          this.abswitch = lastReading.AB_Switch_On_Feedback;
          this.buchholz = lastReading.Transformer_buchholz_Act;
          this.sumplevel = lastReading.Sump_Level;
          this.waterLeveld = lastReading.Water_Flow;
          this.overload = lastReading.overload;
          
            this.lightningTransformerFeedback = lastReading.Lighting_Transformer_On_Feedback;
          
          this.sumpLevel(this.sumplevel);
          //this.totalWaterFlow =  Number(_.sumBy(this.jsonReadings, (o: any) => Number(o['Water_Flow']))).toFixed(2)
          let flowrateperminute = this.waterLeveld / 60;
          let flowrateoftwominutes = flowrateperminute * 2;
          this.totalWaterFlow = Number(flowrateoftwominutes * 720).toFixed(2);

        } else {
          console.log("No valid last readings found.");
        }
        this.updateSelected("motorrphasetemperature");
      }
    });
  }
  formatTitle(str) {
    // Define a map of input strings to their formatted versions
    const titleMap = {
      "motorrphasetemperature": "Motor  Phase Temperature",
      "pumpcurrent": "Current",
      "motorndetemperature": "Motor Nde Temperature",
      "motordetemperature": "Motor De Temperature",
      "pumpdplow": "Pump Discharge Pressure Low",
      "overload": "Overload",
      "Water_Flow": "Water Flow",
      "Sump_Level": "Sump Level",
      "pumponffeedback": "Pump On Off Feedback"
    };

    if (titleMap.hasOwnProperty(str)) {
      return titleMap[str];
    }

  }
  createGraph() {
    this.ngxLoader.startLoader('graphloader');
    let param = this.selectedParameter;
    this.graph.layout = {
      title: this.formatTitle(param),
      xaxis: {
        title: {
          text: 'Time',
          font: {
            family: 'Arial',
            size: 18,
            color: '#000000',
          }
        },
      },
      yaxis: {
        title: {
          text: 'Value',
          font: {
            family: 'Arial',
            size: 18,
            color: '#000000'
          }
        }
      },
    };
    let pumpCurrentArray = this.jsonReadings.map(pump => pump[param]);
      
    if (param == "pumpcurrent") {
        pumpCurrentArray = this.jsonReadings.map(pump => ((pump['L1'] + pump['L2'] + pump['L3']) / 3).toFixed(2));
    }
    if (param != 'motorrphasetemperature') {
   

      if (pumpCurrentArray.length === 0 || this.dateAray.length === 0) {
        this.ngxLoader.stopLoader('graphloader');
        return;
      }

      this.data = [{
        x: this.dateAray,
        y: pumpCurrentArray,
        type: 'scatter',
        text: param,
        mode: 'lines+markers',
        marker: { color: 'blue' }
      }];
    } else {
      const pumpRPhaseArray = this.jsonReadings.map(pump => pump[param]);
      const pumpYPhaseArray = this.jsonReadings.map(pump => pump['motoryphasetemperature']);
      const pumpBPhaseArray = this.jsonReadings.map(pump => pump['motorbphasetemperature']);

      if (pumpRPhaseArray.length === 0 && pumpYPhaseArray.length === 0 && pumpBPhaseArray.length === 0 || this.dateAray.length === 0) {
        this.ngxLoader.stopLoader('graphloader');
        return;
      }

      this.data = [
        {
          x: this.dateAray,
          y: pumpRPhaseArray,
          name: "R Phase",
          type: 'scatter',
          mode: 'lines+markers',
          marker: { color: 'red' }
        },
        {
          x: this.dateAray,
          y: pumpYPhaseArray,
          name: "Y Phase",
          type: 'scatter',
          mode: 'lines+markers',
          marker: { color: 'yellow' }
        },
        {
          x: this.dateAray,
          y: pumpBPhaseArray,
          name: "B Phase",
          type: 'scatter',
          mode: 'lines+markers',
          marker: { color: 'blue' }
        }
      ];
    }
    this.ngxLoader.stopLoader('graphloader');
    this.ngxLoader.stopLoader('dashboard');
  }

}
